/** Retired keys remain valid in saved searches and published content. */
export const WORK_AREA_KEY_REDIRECTS: Readonly<Record<string, string>> = {
  panic_attacks: "anxiety",
  phobias: "anxiety",
  social_anxiety: "anxiety",
  health_anxiety: "anxiety",
  financial_distress: "stress",
  anger: "emotional_regulation",
  impulsivity: "emotional_regulation",
  mood_difficulties: "emotional_regulation",
  shame_guilt: "emotional_regulation",
  perfectionism: "self_esteem",
  communication: "relationships",
  boundaries: "relationships",
  loneliness: "relationships",
  jealousy: "couples_issues",
  separation_divorce: "couples_issues",
  blended_families: "family_issues",
  decision_making: "self_development",
  identity: "self_development",
  spirituality: "self_development",
  menopause: "life_crises",
  involuntary_childlessness: "grief_loss",
  burnout: "work_issues",
  motivation: "procrastination",
  attention_difficulties: "procrastination",
  narcissistic_abuse: "violence_abuse",
  bullying: "violence_abuse",
  caregiver_stress: "chronic_illness",
  adolescents: "work_with_adolescents",
};

export function canonicalWorkAreaKey(key: string): string {
  return WORK_AREA_KEY_REDIRECTS[key] ?? key;
}

export function canonicalWorkAreaKeys(keys: readonly string[]): string[] {
  return [...new Set(keys.map(canonicalWorkAreaKey))];
}
